module.exports = __webpack_public_path__ + "static/media/048-folder-3.751a7551.svg";